import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import bannerhot1 from "../../assets/homepage/body/bannerhot1.png";
import bannerhot2 from "../../assets/homepage/body/bannerhot2-1.png";
import bannerhot3 from "../../assets/homepage/body/bannerhot3.png";
import bannerhot4 from "../../assets/homepage/body/bannerhot4.png";
import bannerhot5 from "../../assets/homepage/body/bannerhot5.png";
import bannerhot6 from "../../assets/homepage/body/bannerhot6.png";

const PromotionTabs = ({
  activeButton,
  setActiveButton,
  promotions,
  promotionsMB,
  visibleCount,
  loadMore,
  loadedImages,
  handleImageLoad,
  clickPromotion,
  rule,
  ruleMobile,
  showTabs = true,
  forceSection = null,
  previewLimit = null,
  enableShowMore = true,
  hidePromotionsContent = false,
  forceScrollable = false,
  scrollMaxHeightClass = "md:max-h-[640px]",
}) => {
  const [showAll, setShowAll] = useState(false);

  // Temporary static promotions while the API is disabled.
  // Restore `promotions/promotionsMB` here when the API is ready again.
  const staticPromotions = [
    // { id: "static-promo-1", imageUrl: bannerhot1 },
    { id: "static-promo-2", imageUrl: bannerhot2 },
    { id: "static-promo-3", imageUrl: bannerhot3 },
    { id: "static-promo-4", imageUrl: bannerhot4 },
    { id: "static-promo-5", imageUrl: bannerhot5 },
    { id: "static-promo-6", imageUrl: bannerhot6 },
  ];

  useEffect(() => {
    setShowAll(false);
  }, [activeButton]);

  const currentSection = forceSection || activeButton;
  const currentPromos = staticPromotions;
  const shouldScroll = forceScrollable || showAll;
  const displayedPromos = previewLimit
    ? currentPromos.slice(0, previewLimit)
    : showAll
      ? currentPromos
      : currentPromos.slice(0, 2);

  const renderPromotionList = () => {
    if (hidePromotionsContent) {
      return null;
    }

    return (
      <div className="w-full max-w-[1280px] mx-auto mt-2 px-3 md:px-0 flex flex-col items-center transition-all duration-500">
        <div
          className={`w-full max-w-[530px] select-none transition-all duration-500 ${shouldScroll
            ? `max-h-[420px] min-[361px]:max-h-[520px] ${scrollMaxHeightClass} overflow-y-auto custom-scrollbar pr-1`
            : ""
            }`}
        >
          <div className="grid grid-cols-1 gap-y-3 md:gap-y-1 w-full pb-4">
            {displayedPromos.map((promotion) => (
              <motion.div
                key={promotion.id}
                initial={{ opacity: 0, y: 0 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{ y: -12 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                className="w-full relative z-10 hover:z-20 cursor-pointer"
                onClick={() => clickPromotion(promotion)}
              >
                {!loadedImages[promotion.id] && (
                  <div className="w-full aspect-[2.7/1] md:w-[530px] md:h-[230px] md:aspect-auto bg-gray-200 animate-pulse md:rounded-[20px]" />
                )}
                <div className="overflow-hidden rounded-[10px] md:rounded-[20px]">
                  <img
                    src={promotion.imageUrl}
                    alt={`img-${promotion.id}`}
                    className="w-full aspect-[2.7/1] md:w-[530px] md:h-[230px] md:aspect-auto object-contain transition-all duration-300 block pointer-events-auto transform hover:brightness-105"
                    loading="lazy"
                    draggable="false"
                    onLoad={() => handleImageLoad(promotion.id)}
                  />
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {enableShowMore && !previewLimit && !showAll && currentPromos.length > 2 && (
          <button
            onClick={() => setShowAll(true)}
            className="mb-5 px-5 py-2 text-white text-lg font-bold rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105"
            style={{ background: "#1678FF" }}
          >
            Xem thêm
          </button>
        )}

        {showAll && !previewLimit && <div className="h-8" />}
      </div>
    );
  };

  return (
    <div className="w-full flex flex-col items-center">
      {showTabs && (
        <div className="w-full max-w-[1000px] px-3 md:px-0 md:mt-8">
          <div
            className="flex rounded-lg md:rounded-2xl w-full overflow-hidden items-stretch"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(220, 240, 255, 0.7) 100%)",
              backdropFilter: "blur(10px)",
              boxShadow: "0px 4px 20px 0px rgba(0, 174, 239, 0.2)",
            }}
          >
            <button
              onClick={() => setActiveButton("promotions")}
              className={`flex-1 md:hidden flex items-center justify-center py-3 px-0.5 md:px-1 text-[10px] max-[430px]:text-[8.2px] md:text-[22px] transition-all duration-300 rounded-lg md:rounded-2xl uppercase min-w-0 ${activeButton === "promotions"
                ? "text-white shadow-md font-semibold"
                : "text-[#5E7DAF] font-normal hover:bg-white/20"
                }`}
              style={
                activeButton === "promotions"
                  ? {
                    background: "#1678FF",
                    boxShadow: "0px 10px 24px 0px rgba(22, 29, 36, 0.16)",
                  }
                  : undefined
              }
            >
              <span
                className="whitespace-nowrap "
                style={{ textShadow: "0.2px 0 currentColor, -0.2px 0 currentColor" }}
              >
                KHUYẾN MÃI HOT
              </span>
            </button>
            <button
              onClick={() => setActiveButton("conditions")}
              className={`flex-1 flex items-center justify-center py-3 px-0.5 md:px-1 text-[10px] max-[430px]:text-[8.2px] md:text-[22px] transition-all duration-300 rounded-lg md:rounded-2xl uppercase min-w-0 ${activeButton === "conditions"
                ? "text-white shadow-md font-semibold"
                : "text-[#5E7DAF] font-normal hover:bg-white/20"
                }`}
              style={
                activeButton === "conditions"
                  ? {
                    background: "#1678FF",
                    boxShadow: "0px 10px 24px 0px rgba(22, 29, 36, 0.16)",
                  }
                  : undefined
              }
            >
              <span
                className=""
                style={{ textShadow: "0.2px 0 currentColor, -0.2px 0 currentColor" }}
              >
                QUY TẮC ĐIỀU KIỆN
              </span>
            </button>
            <button
              onClick={() => {
                setActiveButton("activities");
                window.location.href = "";
              }}
              className={`flex-1 flex items-center justify-center py-3 px-0.5 md:px-1 text-[10px] max-[430px]:text-[8.2px] md:text-[22px] transition-all duration-300 rounded-lg md:rounded-2xl uppercase min-w-0 ${activeButton === "activities"
                ? "text-white shadow-md font-semibold"
                : "text-[#5E7DAF] font-normal hover:bg-white/20"
                }`}
              style={
                activeButton === "activities"
                  ? {
                    background: "#1678FF",
                    boxShadow: "0px 10px 24px 0px rgba(22, 29, 36, 0.16)",
                  }
                  : undefined
              }
            >
              <span
                className="whitespace-nowrap "
                style={{ textShadow: "0.2px 0 currentColor, -0.2px 0 currentColor" }}
              >
                HOẠT ĐỘNG Ý NGHĨA
              </span>
            </button>
          </div>
        </div>
      )}

      <div className="w-full overflow-hidden relative">
        {currentSection === "promotions" ? (
          renderPromotionList()
        ) : currentSection === "conditions" ? (
          <div className="mt-2 md:mt-8 mb-8 px-3 md:px-0 flex justify-center w-full">
            <div className="hidden md:block w-full max-w-[1280px]">
              <img src={rule} alt="Rule" className="w-auto h-auto max-w-full mx-auto" />
            </div>
            <div className="md:hidden w-full max-w-md max-h-[450px] min-[361px]:max-h-[500px] overflow-y-auto custom-scrollbar pr-1">
              <img src={ruleMobile} alt="RuleMobile" className="w-auto h-auto max-w-full" />
            </div>
          </div>
        ) : (
          <div className="mt-12 mb-12 flex flex-col items-center text-gray-500">
            <p className="text-xl">Llwin Thiện nguyện</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PromotionTabs;
